<template>
  <div class="setupdefinition-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('setupdefinition_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-clipboard-list</v-icon>{{$t('profile.setupdefinition.definitions')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <SetupDefinitionFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.extruderQuantity" slot-scope="{ item }">
                  {{ $n(item['extruderQuantity']) }}
                </template>
                <template slot="item.tempControler" slot-scope="{ item }">
                  {{ $n(item['tempControler']) }}
                </template>
                <template slot="item.setupDefinitionSubs" slot-scope="{ item }">
                  <ul>
                    <li v-for="_item in item['setupDefinitionSubs']" :key="_item.id">
                      {{ _item.id }}
                    </li>
                  </ul>
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import SetupDefinitionFilterForm from '../../components/setupdefinition/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'SetupDefinitionList',
  servicePrefix: 'SetupDefinition',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    SetupDefinitionFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.setupdefinition.uuid'), value: 'uuid' },
        { text: this.$t('profile.setupdefinition.extruderquantity'), value: 'extruderQuantity' },
        { text: this.$t('profile.setupdefinition.tempcontroler'), value: 'tempControler' },
        { text: this.$t('profile.setupdefinition.machine'), value: 'machine.name' },
        { text: this.$t('profile.setupdefinition.toolhead'), value: 'toolHead.name' },
        { text: this.$t('profile.setupdefinition.materialsupply'), value: 'materialSupply.name' },
        { text: this.$t('profile.setupdefinition.printingsurface'), value: 'printingSurface.name' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('setupdefinition', {
      items: 'list'
    }),
    ...mapFields('setupdefinition', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('setupdefinition', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
